const hourWidth = 200;
const pixelMultiplier = hourWidth / 60;
const refreshTimeInSeconds = 60;

const cellLengthInMinutes = 5;
export { pixelMultiplier, hourWidth, cellLengthInMinutes, refreshTimeInSeconds };
